// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Grid, Segment } from 'semantic-ui-react'
import bgimg from '../assets/herobg3.png'
import hero from '../assets/woocommerce.png'
import Img from 'react-image'

export default class HeroWoo extends Component {
  render () {
    return (
      <div
        style={{
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'repeat',
          backgroundImage: 'url(' + bgimg + ')'
        }}>
        <Grid
          reversed='mobile'
          stackable
          verticalAlign='middle'
          style={{ paddingTop: '5vh', paddingBottom: '5vh' }}>
          <Grid.Column width='2' />
          <Grid.Column width='6'>
            <Segment padded='very' style={{ borderRadius: '7px' }}>
              <h1>
                {' '}
                Convert your WooCommerce store to a native mobile app in a fraction of the time and
                cost
              </h1>
              <h4>
                Our app template connects to WordPress and WooCommerce by few clicks and starts
                working out of the box.
              </h4>
            </Segment>
          </Grid.Column>
          <Grid.Column width='6' className='center'>
            <Img src={hero} style={{ height: 300 }} />
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}
